@for (swatch of field.values; track swatch) {
    <span class="swatch mr-1 mb-1" [class.swatch--small]="field.options?.size === 'small'" [title]="swatch.value">
        <kui-color-picker
            [color]="getValue(swatch.key)"
            [size]="field.options?.size || 'large'"
            [position]="field.options?.position || 'left'"
            (onChange)="setValue(swatch.key, $event)"
        ></kui-color-picker>
        @if (swatch.value && field.options?.size !== "small") {
            <span class="swatch__name">{{ swatch.value }}</span>
        }
    </span>
}
